import { VisibilityDto } from '@/api/ApiClient';

/** UI labels for {@link VisibilityDto} (matches server `Tools/Enums/Visibility.cs`). */
export const VISIBILITY_LABELS: Record<VisibilityDto, string> = {
  [VisibilityDto.Internal]: 'Internal',
  [VisibilityDto.UserPI]: 'User PI',
  [VisibilityDto.OnPublication]: 'On Publication',
};

/** Dropdown order for visibility selects. */
export const VISIBILITY_OPTIONS: VisibilityDto[] = [
  VisibilityDto.Internal,
  VisibilityDto.UserPI,
  VisibilityDto.OnPublication,
];

export function isVisibilityDto(value: unknown): value is VisibilityDto {
  return typeof value === 'string' && value in VISIBILITY_LABELS;
}

/** Display label for a visibility code from the API. */
export function getVisibilityTypeDisplay(visibility: VisibilityDto | string | null | undefined): string {
  if (!visibility) {
    return '';
  }
  if (isVisibilityDto(visibility)) {
    return VISIBILITY_LABELS[visibility];
  }
  return visibility;
}

/** Value/label pairs for MUI Select and FormSelect. */
export function visibilitySelectOptions(): { value: VisibilityDto; label: string }[] {
  return VISIBILITY_OPTIONS.map((value) => ({
    value,
    label: VISIBILITY_LABELS[value],
  }));
}
